import { useMutation, useQuery } from "@tanstack/react-query";
import { volunteerAssignmentApiService } from "./volunteerAssignmentApiService.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useVolunteerAssignmentService = ({
  studyId,
  searchText,
  pageNumber = 1,
  pageSize = 10,

  volunteerassignmentid,
  assignmentstatus,
  enabled = false,
}: {
  studyId?: number | null;
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;

  volunteerassignmentid?: number | null;
  assignmentstatus?: string | null;
  enabled?: boolean;
} = {}) => {

  // Dropdown


  // SelectAll
  const SelectAllQuery = useQuery({
    queryKey: [
      "volunteer-assignment-selectAll",
      studyId,
      searchText,
      pageNumber,
      pageSize,
      assignmentstatus,
    ],
    queryFn: () =>
      volunteerAssignmentApiService.getSelectAllData(
        studyId,
        searchText,
        pageNumber,
        pageSize,

        assignmentstatus,
      ),
    enabled: enabled && !!studyId,               // prevent early call
  });

  // select printlog
  const SelectLogQuery = useQuery({
      queryKey: [
        "volunteer-assignment-selectlog",
        volunteerassignmentid,
        searchText,
        pageNumber,
        pageSize,
      ],
      queryFn: () => 
        volunteerAssignmentApiService.getSelectLogData(
          volunteerassignmentid,
          searchText,
          pageNumber,
          pageSize,
      
      ),
      enabled: !!volunteerassignmentid, // only fetch when valid id
      refetchOnWindowFocus: false,
      refetchOnMount: false,
  });

  // Insert
  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
        volunteerAssignmentApiService.insertData(payload),
  });

  const LogInsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
      volunteerAssignmentApiService.loginsert(payload),
  });

  const LogBulkInsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
      volunteerAssignmentApiService.logbulkinsert(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
      mutationFn: (payload: any) =>
        volunteerAssignmentApiService.updateData(payload),
  });

  // Delete
  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { volunteerid: number| null; updatereason: string }
  >({
    mutationFn: (payload) =>
      volunteerAssignmentApiService.deleteData(payload),
  });

  return {
    SelectAllQuery,
    SelectLogQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
    LogInsertMutation,
    LogBulkInsertMutation,
  };
};
